import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
// import Commissioner from '../../../assets/images/commissioner.png';
import { useDispatch, useSelector } from 'react-redux';
import { CustomizerState } from '../../../store/ActionReducers/customizer.actionreducer';
import { fetchMessageFromChief } from '../../../services/customizer.service';

interface state{
  customizer:CustomizerState
}

const MessageFromChairMan:React.FC = ()=>{

  const dispatch = useDispatch();

  const state = useSelector((state:state)=>state.customizer);
  const {messageFromChief} = state;

  const fetchMFC = () =>{
    dispatch(fetchMessageFromChief());
  }

  useEffect(()=>{
    if(!messageFromChief) fetchMFC();
  },[]) // eslint-disable-line


  return(
    <div className="bg-white m-15 br-6px chief-message">
    {messageFromChief?
      <div className='p-15 home-about'>
          
          <Grid container>


          <Grid item md={12} lg={12} xl={12}>
              <figure className="img-with-overlay">
                <img src={messageFromChief.value.image} alt=""/>
                <div className="overlay">
                  <div className="abt-commissioner">
                    <p className="text-14-white text-center">{messageFromChief.value.spokeperson}</p>
                    <h3 className="text-16-white text-center">{messageFromChief.value.designation}</h3>
                  </div>
                </div>
              </figure>
            </Grid>

            <Grid item md={12} lg={12} xl={12}>
              <div className="home-about--info mt-1">
                <h3 className="text-22">{messageFromChief.name}</h3>
                <p className='text-14-black text-justify'>
                  {messageFromChief.value.description}
                </p>
              </div>
            </Grid>
           
          </Grid>
          
      </div>
    :''}
    </div>
  );
}

export default MessageFromChairMan;